import type { IndexFiltersProps } from '@shopify/polaris';

export const SORT_BILLING_CYCLE: IndexFiltersProps['sortOptions'] = [
  { label: 'Cycle', value: 'CYCLE_START_DATE asc', directionLabel: 'Ascending' },
  { label: 'Cycle', value: 'CYCLE_START_DATE desc', directionLabel: 'Descending' },
  // { label: 'Recorded revenue', value: 'USAGE_AMOUNT asc', directionLabel: 'Ascending' },
  // { label: 'Recorded revenue', value: 'USAGE_AMOUNT desc', directionLabel: 'Descending' },
  // { label: 'Usage fee', value: 'PRICE asc', directionLabel: 'Ascending' },
  // { label: 'Usage fee', value: 'PRICE desc', directionLabel: 'Descending' },
  // { label: 'Status', value: 'STATUS asc', directionLabel: 'Ascending' },
  // { label: 'Status', value: 'STATUS desc', directionLabel: 'Descending' },
];

export const SORT_DEFAULT = ['CYCLE_START_DATE desc'];
